module.exports = {"513323100":"章谷镇","513323101":"巴底镇","513323102":"革什扎镇","513323201":"巴旺乡","513323202":"聂呷乡","513323204":"边耳乡","513323205":"丹东乡","513323206":"东谷乡","513323207":"水子乡","513323208":"格宗乡","513323209":"梭坡乡","513323210":"中路乡","513323211":"岳扎乡","513323212":"半扇门乡","513323213":"太平桥乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513323.json
// module id = 2228
// module chunks = 0